import React from 'react'
import {
  Area,
  CartesianGrid,
  ComposedChart,
  Legend,
  Line,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts'

import generateDataKeys from '../helpers/generateDataKeys'

const LitAreaChart = props => {
  const {
    height, // int
    data, // object
    color, // string
    xAxis, //string
    yAxis, //string
    hide,
    type,
    tooltip,
    legend, // bool
    gradient, //bool
    dataKeys: dataKeys = generateDataKeys(data, xAxis, yAxis), //object with key and color
  } = props

  const CustomTooltip = ({ active, payload, label }) => {
    if (active) {
      return (
        <table style={{ background: '#fff' }}>
          <caption
            style={{
              fontWeight: 'bold',
              background: '#eee',
              display: 'block',
              width: '100%',
              padding: '.5em .25em',
              textAlign: 'center',
            }}
          >{`${label}`}</caption>
          <tbody style={{ display: 'block' }}>
            {payload &&
              payload.map((payload, i) => (
                <tr key={i}>
                  <th style={{ padding: '0.25rem 0.25rem 0.25rem' }}>
                    <span
                      style={{
                        paddingRight: '.5em',
                        color: payload.stroke,
                        textShadow: '#000 0px 0px 1px',
                      }}
                    >
                      ●
                    </span>
                    <span style={{ textTransform: 'capitalize' }}>
                      {payload.name}:{' '}
                    </span>
                  </th>
                  <th
                    style={{
                      textAlign: 'right',
                      padding: '0.25rem 0.25rem 0.25rem',
                    }}
                  >
                    {' '}
                    {isNaN(payload.value)
                      ? '-'
                      : payload.value.toLocaleString()}
                  </th>
                </tr>
              ))}
          </tbody>
        </table>
      )
    }

    return null
  }

  return (
    <ResponsiveContainer width="100%" height={height || 340}>
      <ComposedChart data={data}>
        <defs>
          {dataKeys &&
            dataKeys.map((item, i) => (
              <linearGradient
                key={i}
                id={`${item.key.replace(/\s/g, '') + item.color}`}
                x1="0"
                y1="0"
                x2="0"
                y2="1"
              >
                <stop
                  offset="100%"
                  stopColor={item.color || color}
                  stopOpacity={1}
                />
                <stop
                  offset="100%"
                  stopColor={item.color || color}
                  stopOpacity={0}
                />
              </linearGradient>
            ))}
        </defs>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis hide={hide ? true : false} stroke={color} dataKey={xAxis} />
        <YAxis hide={hide ? true : false} stroke={color} dataKey={yAxis} />
        {tooltip !== false && <Tooltip content={<CustomTooltip />} />}
        {dataKeys &&
          dataKeys.map((item, i) =>
            type === 'area' ? (
              <Area
                animationDuration={1000}
                key={i}
                type="monotone"
                dataKey={item.key}
                stroke={item.color}
                fill={
                  gradient
                    ? `url(#${item.key.replace(/\s/g, '') + item.color})`
                    : item.color
                }
              />
            ) : (
              <Line
                animationDuration={1000}
                key={i}
                strokeWidth={height < 200 ? 2 : 3}
                type="monotone"
                dataKey={item.key}
                stroke={item.color}
                dot={false}
              />
            )
          )}
        {legend && <Legend />}
      </ComposedChart>
    </ResponsiveContainer>
  )
}

export default LitAreaChart
